import React, { useContext } from 'react';
import { useBreakpoint } from '../misc/useBreakpoint';
import { Lock } from 'lucide-react';
import { UserContext } from '../contexts/UserProvider';
import { STRIPE_BILLING_PORTAL_URL,  } from '../misc/constants';

const PastDueScreen = () => {
  const { user } = useContext(UserContext);
  const { isMobileAndBelow } = useBreakpoint();
  const CONTAINER_STYLE = { display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: isMobileAndBelow ? '100dvh' : '90vh', width: isMobileAndBelow ? '100%' : '80%', maxWidth: '500px', margin: isMobileAndBelow ? '0' : 'auto', backgroundColor: '#fff', padding: '1rem', borderRadius: isMobileAndBelow ? '0' : '10px', boxShadow: isMobileAndBelow ? 'none' : '0 4px 8px rgba(0, 0, 0, 0.1)', position: 'relative' }


  const handleBillingClick = () => {
    let url = ''

    if (user?.stripeSubscription?.paymentProvider == 'paddle') {
      url = process.env.REACT_APP_PADDLE_BILLING_PORTAL_URL;
    }
    else {
      url = STRIPE_BILLING_PORTAL_URL;
    }
    
    window.open(url, '_blank');
  }


return (
  <div style={CONTAINER_STYLE}>
  <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
    <Lock size={36} style={{ color: 'var(--color-primary)', marginBottom: '1rem' }} />
    <h1 style={{ fontSize: '24px', fontWeight: '600', marginBottom: '1rem', color: '#333' }}>You Missed Your Last Payment</h1>
    <p style={{ fontSize: '16px', color: '#666', marginBottom: '2rem', maxWidth: '400px', lineHeight: '1.5' }}>
      We'd love to continue to helping you to hit your academic goals. To continue using School Goat and regain access to your account, please update your billing information below.
    </p>
    <button 
      onClick={() => handleBillingClick()} 
      style={{
        width: "100%",
        backgroundColor: 'var(--color-text1)',
        color: 'var(--color-textButton)',
        padding: '12px 24px',
        border: 'none',
        borderRadius: '8px',
        fontSize: '16px',
        fontWeight: '500',
        cursor: 'pointer',
        transition: 'background-color 0.2s ease',
      }}
    >
      Go to Billing Center
    </button>
    </div>
  </div>
);
};

export default PastDueScreen;
